export const FETCH_FUEL_BILLS = 'FETCH_FUEL_BILLS';
export const FETCH_FUEL_BILLS_COUNT = 'FETCH_FUEL_BILLS_COUNT';
export const ADD_FUEL_BILL_SUCCESS = 'ADD_FUEL_BILL_SUCCESS';
export const EDIT_FUEL_BILL_SUCCESS = 'EDIT_FUEL_BILL_SUCCESS';
